var mapStyle = [
    {
        "featureType": "administrative",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            },
            {
                "hue": "#0066ff"
            },
            {
                "saturation": 74
            },
            {
                "lightness": 100
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            },
            {
                "weight": 0.6
            },
            {
                "saturation": -85
            },
            {
                "lightness": 61
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            },
            {
                "color": "#5f94ff"
            },
            {
                "lightness": 26
            },
            {
                "gamma": 5.86
            }
        ]
    }
];

var map = infowindow = null;
var filters = ['woningtype', 'oppervlakte', 'status'];

function initializeMap() {
    var myLatLng = new google.maps.LatLng(52.366158, 4.930047);

    var mapOptions = {
        center: myLatLng,
        zoom: 16,
        styles: mapStyle
    };

    map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);
    map.markers = [];

    var image = {
        url: '/images/google-icon-' + website + '.png',
        size: new google.maps.Size(180, 143),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(20, 50),
        scaledSize: new google.maps.Size(90, 72)
    };

    infowindow = new google.maps.InfoWindow({
        pixelOffset: new google.maps.Size(0, -50),
    });

    $.getJSON(pointerUrl, function (pointers) {
        $.each(pointers, function (key, data) {
            var myLatLng = new google.maps.LatLng(data.latitude, data.longitude);

            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                data: data,
                icon: image,
            });

            google.maps.event.addListener(marker, 'click', function () {
                showInfo(marker);
            });

            marker.setMap(map);
            map.markers.push(marker);
        });

        filter();
    });
}

function showInfo(marker) {
    var contentString = '<div class="googleInfo"><p><a href="' + marker.data.link + '">' + marker.data.adres + '</a><br /><span><i class="icon icon-euro"></i>' + marker.data.prijs + '</span><span><i class="icon icon-map-marker-multiple"></i>' + marker.data.plaats + '</span></p></div>';

    infowindow.setContent(contentString);
    infowindow.setPosition(marker.position);
    infowindow.open(map);
}

$('form#filter select').on('changed.bs.select', function (e, index) {
    filter();
});

function filter() {
    var useFilters = [];
    $.each(filters, function (index, value) {
        if ($("form#filter select[name='" + value + "'").val() != 'all') useFilters.push(value);
    });

    $.post('/filter/kaart', $("form#filter").serialize());

    var bounds = new google.maps.LatLngBounds();

    if (useFilters.length !== 0) {
        var sStatus = false;
        var sOppervlakte = false;
        var sWoningtype = false;
        if ($.inArray('status', useFilters) != -1) sStatus = $("form#filter select[name='status']").val();
        if ($.inArray('oppervlakte', useFilters) != -1) sOppervlakte = $("form#filter select[name='oppervlakte']").val();
        if ($.inArray('woningtype', useFilters) != -1) sWoningtype = $("form#filter select[name='woningtype']").val();

        $.each(map.markers, function () {
            var currentMarker = this;
            var show = true;

            if (sStatus && !currentMarker.data[sStatus]) show = false;
            if (sOppervlakte && !(parseInt(currentMarker.data.oppervlakte) >= sOppervlakte)) show = false;
            if (sWoningtype && currentMarker.data.woningtype_id != sWoningtype) show = false;

            if (show) {
                bounds.extend(this.position);
                if (this.map == null) this.setMap(map);
            } else {
                this.setMap(null);
            }
        });
    } else {
        $.each(map.markers, function () {
            bounds.extend(this.position);
            this.setMap(map);
        });
    }

    map.fitBounds(bounds);
    if (map.getZoom() > 15) map.setZoom(15);
};

google.maps.event.addDomListener(window, 'load', initializeMap);









